import { CUSTOMER_PROFILE } from "../actionTypes";

const customer_profile = (data) => {
  return {
    type: CUSTOMER_PROFILE,
    data: data,
  };
};

export { customer_profile };